import React, { useState } from 'react';
import { BiPencil } from 'react-icons/bi';
import { toast } from 'react-toastify';
import PermissaoWrapper from '../../../../components/PermissaoWrapper';
import Usuario from '../../../../model/Usuario/Usuario';
import { PermissaoEnum } from '../../../../model/Usuario/Permissao';
import { Perfil } from '../../../../model/Usuario/Perfil';
import UsuarioViewModel from '../../../../viewmodel/usuario/UsuarioViewModel';
import { getPerfilColor } from '../../../../utils/perfilColors';
import EditarPerfilModal from '../EditarPerfilModal';
import './TabelaUsuarios.css';

interface TabelaUsuariosProps {
  usuarios: Usuario[];
  loading: boolean;
  onUsuarioUpdated: () => void;
  perfisDisponiveis: Perfil[];
}

const TabelaUsuarios: React.FC<TabelaUsuariosProps> = ({ usuarios, loading, onUsuarioUpdated, perfisDisponiveis }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUsuario, setSelectedUsuario] = useState<Usuario | null>(null);

  const handleEdit = (usuario: Usuario) => {
    setSelectedUsuario(usuario);
    setShowEditModal(true);
  };

  const handleSavePerfil = async (updatedUsuario: Usuario) => {
    try {
      await UsuarioViewModel.updatePerfil(updatedUsuario.id!, updatedUsuario.perfil!.id!);
      toast.success('Perfil modificado com sucesso');
      onUsuarioUpdated();
      setShowEditModal(false);
      setSelectedUsuario(null);
    } catch (error) {
      toast.error('A troca de Perfil não é permitida');
    }
  };

  if (loading) {
    return (
      <div className="table-container">
        <div className="loading-container">
          <div className="spinner-border" role="status"></div>
        </div>
      </div>
    );
  }

  if (usuarios.length === 0) {
    return (
      <div className="table-container">
        <div className="empty-state">
          <p>Nenhum usuário encontrado com os filtros aplicados.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-container">
      <div className="table-responsive">
        <table className="usuarios-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Matrícula</th>
              <th>Perfil</th>
              <PermissaoWrapper permissoesRequiridas={[PermissaoEnum.ALTERAR_USUARIO]}>
                <th style={{ textAlign: 'center' }}>Ações</th>
              </PermissaoWrapper>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((usuario: Usuario) => (
              <tr key={usuario.id}>
                <td>{usuario.nome}</td>
                <td>{usuario.email}</td>
                <td>{usuario.matricula || 'Não informado'}</td>
                <td>
                  <span
                    className="perfil-badge"
                    style={{
                      ...getPerfilColor(usuario.perfil?.nome || 'sem perfil'),
                      padding: '6px 12px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase'
                    }}
                  >
                    {usuario.perfil?.nome || 'Nenhum'}
                  </span>
                </td>
                <PermissaoWrapper permissoesRequiridas={[PermissaoEnum.ALTERAR_USUARIO]}>
                  <td style={{ textAlign: 'center' }}>
                    <button
                      style={{
                        backgroundColor: '#e3f2fd',
                        color: 'black',
                        border: '1px solid gray',
                        borderRadius: '4px',
                        padding: '4px 8px',
                        fontSize: '12px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                      }}
                      title="Editar Perfil"
                      onClick={() => handleEdit(usuario)}
                    >
                      <BiPencil />
                    </button>
                  </td>
                </PermissaoWrapper>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedUsuario && (
        <EditarPerfilModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          usuario={selectedUsuario}
          perfisDisponiveis={perfisDisponiveis}
          onSave={handleSavePerfil}
        />
      )}
    </div>
  );
};

export default TabelaUsuarios;